import React from "react";
import PropTypes from "prop-types";
import { Grid, Stack, Box, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Select, CommonModal } from "../Common/index";
import { Grey3, trakrefBlue, trakrefDisabledBlue, White } from "../../color_utils";
import { trakrefFontFamilyBold } from "../../utils";

const CreateEpaAlertDialog = ({
  open,
  onModalClose,
  leakRatePercent,
  isLoading,
  isDeleteLoading,
  headerName,
  buttonTitle,
  onDelete,
  onSave,
  leakRate,
  options,
  handleOnChange,
  disabled,
  headerWidth
}) => {
  return (
    <CommonModal
      open={open}
      close={onModalClose}
      header={headerName}
      headerTopMargin={8}
      bottom={24}
      scroll="paper"
      width='500px'
      headerWidth={headerWidth}
    >
      <Grid container pl={10} pr={10}>
        <Grid item xs={12} lg={12} mb={2} pt={2} align="center">
          <Stack spacing={3}>
            <Select
              required={leakRate.value != null}
              fullWidth
              variant={"standard"}
              label={`${leakRate.value == null && leakRatePercent == 0 ? "" : "Leak rate exceeds (%)"}`}
              options={options}
              transformLabel={false}
              labelColor={Grey3}
              dropdownIconSize='16px'
              value={leakRate.value != null ? leakRate.value : leakRatePercent}
              renderValue={(val)=>{
                return <span>{`${val == 0 && leakRatePercent == 0 ? 'Leak rate exceeds (%)*': `${val}%`}`}</span>
            }}
              onChange={(e) => {
                handleOnChange(e.target.value);
              }}
              error={leakRate.hasError}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} lg={12} align="center">
          <Box mt={2} mb={2} sx={{ width: "100%" }}>
            <LoadingButton
              fullWidth
              disabled={disabled}
              size="large"
              variant="contained"
              loading={isLoading}
              onClick={onSave}
              sx={{
                padding: "16px 0",
                "& .MuiCircularProgress-root": {
                  color: White,
                  width: "21px !important",
                  height: "21px !important",
                },
              }}
              style={{
                backgroundColor: disabled ? trakrefDisabledBlue : trakrefBlue,
              }}
            >
              <Typography
                sx={{
                  fontFamily: trakrefFontFamilyBold,
                  color: isLoading ? "transparent" : White,
                  backgroundColor: disabled ? trakrefDisabledBlue : trakrefBlue,
                  letterSpacing: "1.2px",
                  padding: "1% 0%",
                  fontSize: 17,
                  fontWeight: 400,
                }}
              >
                {buttonTitle}
              </Typography>
            </LoadingButton>
            {leakRatePercent> 0 && (
              <LoadingButton
                fullWidth
                size="large"
                variant="contained"
                loading={isDeleteLoading}
                onClick={onDelete}
                sx={{
                  "& .MuiCircularProgress-root": {
                    color: trakrefBlue,
                    width: "21px !important",
                    height: "21px !important",
                  },
                  ":hover": {
                    boxShadow: "none",
                  },
                  marginTop: "15px",
                  boxShadow: "none",
                }}
                style={{
                  backgroundColor: "transparent",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: trakrefFontFamilyBold,
                    color: isDeleteLoading ? "transparent" : trakrefBlue,
                    letterSpacing: "1.2px",
                    padding: "1% 0%",
                    fontSize: 17,
                    fontWeight: 400,
                  }}
                >
                  DELETE ALERT
                </Typography>
              </LoadingButton>
            )}
          </Box>
        </Grid>
      </Grid>
    </CommonModal>
  );
};

CreateEpaAlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  leakRate: PropTypes.number.isRequired,
  alias: PropTypes.object,
  onSaveSuccess: PropTypes.func.isRequired,
};

export default CreateEpaAlertDialog;
